export default "__VITE_ASSET__e78bf58f__"